module.exports = __webpack_public_path__ + "img/white.a4e4d6ca.png";